import React, { useState, useEffect } from 'react';
import { NumberInput, useRecordContext } from 'react-admin';
import { useWatch, useFormContext } from 'react-hook-form';
import moment from 'moment';

import { getHolidays } from '../../../services/holidays';


const DurationInput = (props) => {
	const record = useRecordContext();
	const { setValue } = useFormContext();
	const startDate = useWatch({ name: 'start_date' });
	const endDate = useWatch({ name: 'end_date' });
	const halfDay = useWatch({ name: 'half_day' });
	const duration = useWatch({ name: 'duration' });
	const [ready, setReady] = useState(false);

	useEffect(() => {
		if (!record) {
			setReady(true);
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const getWorkingDays = async () => {
			if (startDate && endDate) {
				setValue('duration', null);
				let days = 0;
				let current = moment(startDate);
				const holidays = await getHolidays(current.year());

				while (current.isSameOrBefore(endDate, 'day')) {
					const isWeekend = current.day() === 0 || current.day() === 6;
					const isHoliday = holidays?.some(h => h.date === current.format('YYYY-MM-DD'));

					if (!isWeekend && !isHoliday) {
						days++;
					}

					current.add(1, 'day');
				}

				if (days > 0) {
					setValue('duration', days);
				}
			}
		};

		if (record?.start_date !== startDate || record?.end_date !== endDate) {
			getWorkingDays();
			setValue('half_day', false);
		}
	}, [startDate, endDate]); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (!ready) return;

		if (halfDay) {
			setValue('duration', 0.5);
		}
		else if (!halfDay && duration === 0.5) {
			setValue('duration', 1);
		}
	}, [halfDay]); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (record?.duration === 0.5) {
			setValue('half_day', true);
		}

		setReady(true);
	}, [record]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<NumberInput source="duration" label="Number of days" step={0.5} min={0.5} {...props} />
	);
};

export default DurationInput;